import { VesselStatus } from '../../../helpers/vessel';
import { Tooltip } from 'react-leaflet';

type IProps = {
  dataStatus: VesselStatus;
  name: string;
  showVesselLabel: boolean;
};

const MapTooltip: React.FC<IProps> = ({
  dataStatus,
  name,
  showVesselLabel,
}) => {
  let status = 'custom-tooltip-online';

  if (dataStatus === VesselStatus.ONLINE) {
    status = 'custom-tooltip-online';
  } else if (dataStatus === VesselStatus.WAITING_DATA) {
    status = 'custom-tooltip-waiting-data';
  } else {
    status = 'custom-tooltip-offline';
  }

  if (showVesselLabel) {
    return (
      <Tooltip
        key={`${name}-${status}`}
        className={`custom-tooltip ${status}`}
        direction='bottom'
        offset={[0, 15]}
        opacity={1}
        permanent
      >
        {name}
      </Tooltip>
    );
  } else {
    return (
      <Tooltip
        key={`${name}-${status}-2`}
        className={`custom-tooltip ${status}`}
        direction='bottom'
        offset={[0, 20]}
        opacity={1}
      >
        {name}
      </Tooltip>
    );
  }
};

export default MapTooltip;
